// https://www.youtube.com/watch?v=YeSzQzfcQCs

<template >
  <div id="app">
    <div class="background">
      <div class="overlay"></div>
    </div>
    <div class="navbar-component">
      <navbar />
    </div>
    <div v-if="getHome($route.name)">
      <AppHome />
    </div>
    <div v-else>
      <!-- <navbar2 /> -->
      <div class="main-container container">
        <div v-if="darken" class="darken" aria-hidden="true"></div>
        <BuilderRouter/>      
        <RecentBuilds />
      </div>
    </div>
      <Footer />
      <PriceVisibilityToggle />
      <FeedbackWidget v-if="isBuilderRoute" />
      <!-- <footer class="footer">footer</footer> -->
  </div>
</template>

<script>
import                              'es6-promise/auto'
import navbar                 from  './components/navbar.vue'
import { mapActions, mapGetters }         from  'vuex'
import BuilderRouter          from  './components/builder/BuilderRouter.vue'
import AppHome                from  './components/AppHome.vue'
import RecentBuilds           from  './components/RecentBuilds.vue'
import Footer                 from './components/Footer.vue'
import PriceVisibilityToggle  from './components/PriceVisibilityToggle.vue'
import FeedbackWidget         from './components/builder/FeedbackWidget.vue'
import {EventBus}               from './eventBus'
import bg                     from '@/assets/img/builder-bg.png' 

export default {
  name: 'app',
  components: {
    BuilderRouter,
    RecentBuilds,
    navbar,
    AppHome,
    Footer,
    PriceVisibilityToggle,
    FeedbackWidget
  },

  data() {
    return {
      bgUrl: bg,  // webpack resolves this
      cart: {},
      startLoadTime: 0,
      darken: false,
    }
  },
  mounted(){
    EventBus.$on('extended', (bool) => {
      this.darken = bool
    })
  },
  beforeMount(){
    this.startLoadTime = performance.now()
  },
  watch: {
    loggedIn(){},
  },
  methods: {
    ...mapActions([
      'fetchMiningProfitability',
      'unsetItem'
    ]),
    getHome(route){
      console.log('current route: ', route)
      if(route == 'App' || route == 'AppHome'){
  
        return true
      }
      else return false
    },
  },
  props: ["menu"],
  computed: {
    ...mapGetters([
      'allProcessors',
      'loggedIn'
    ]),
    isBuilderRoute() {
      return this.$route.path === '/builder' || this.$route.path.indexOf('/builder/') === 0
    },
    bgStyle() {
      return {
        backgroundImage: `url('${this.bgUrl}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        position: 'relative'
      }
    }
  },
  created(){
    // this.fetchMiningProfitability()
    console.log('APP LOADED IN ', ((performance.now() - this.startLoadTime)/1000).toFixed(2), ' seconds')
  },
  destroyed(){
    this.unsetItem()
  }
}

</script>

<style>
::-webkit-scrollbar { 
   display: none; 
}
/* @import 'assets/css/bootstrap.min.css'; */
@import 'assets/css/custom.css';
@import 'assets/css/toolkit-inverse.css';
@import 'assets/css/admin-drawers.css';
html {
  background-color: #191b20 !important;
}

/* Shared admin page-hero header. Every /users dashboard page re-declares the
   `.label` header (eyebrow + title on the left, an action on the right) in its
   own scoped styles. These rules live above the routed page (higher specificity,
   confined to `.dashboard-shell` so the builder is untouched) so the header is
   consistent and never gets cramped/squeezed:
   - steady vertical breathing room (it isn't shrunk against the content),
   - the title block may shrink/ellipsis instead of crushing the action,
   - the action keeps its natural size and drops below on tight widths. */
.dashboard-shell .page-router-component .label {
  flex-wrap: wrap;
  gap: 0.45rem 1rem;
  min-height: 54px;
  padding-bottom: 10px;
}
.dashboard-shell .page-router-component .label > div:first-child {
  min-width: 0;
}
.dashboard-shell .page-router-component .label > :not(:first-child) {
  flex-shrink: 0;
}

/* Standard action-button look + height inside every admin drawer. Each drawer
   uses a different per-page button class (.gc-act / .act / .btn-run / .row-btn /
   .btn-refresh) at slightly different heights; this lines them all up at a
   consistent 36px pill. Scoped to the drawer panels so the same classes used in
   tables/heroes (e.g. .row-btn rows, hero .btn-refresh) are NOT affected. Colors
   stay per-class so primary/danger actions remain distinct. */
.dashboard-shell .prompt-panel .row-btn,
.dashboard-shell .prompt-panel .btn-refresh,
.dashboard-shell .cand-panel .act,
.dashboard-shell .job-panel .btn-run,
.dashboard-shell .part-panel .gc-act,
.dashboard-shell .user-panel .gc-act {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  height: auto;
  margin-bottom: 0;
  padding: 0 14px;
  border-radius: 7px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1;
}

/* Keep the action rows aligned and evenly spaced so equal-height buttons sit on
   one tidy baseline. */
.dashboard-shell .prompt-panel .prompt-actions,
.dashboard-shell .cand-panel .panel-foot,
.dashboard-shell .part-panel .part-panel-actions,
.dashboard-shell .user-panel .user-panel-actions,
.dashboard-shell .job-panel .panel-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
  .header {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
  .navbar-component,
.main-container,
footer {
  position: relative;
  z-index: 1;
}

  .main-container {
    margin-top: 28px;
  }

.gix-tooltip {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
  max-width: 280px;
  padding: 9px 11px;
  border: 1px solid rgba(67, 72, 87, 0.76);
  border-left: 2px solid rgba(25, 151, 198, 0.82);
  border-radius: 6px;
  background: rgba(9, 12, 18, 0.97);
  color: #b7c0cf;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.48;
  letter-spacing: 0;
  white-space: pre-line;
  pointer-events: none;
  opacity: 0;
  transform: translateY(4px);
  box-shadow:
    0 14px 30px rgba(0, 0, 0, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.025);
  transition: opacity 130ms ease, transform 130ms ease;
}

.gix-tooltip--below {
  transform: translateY(-4px);
}

.gix-tooltip--visible {
  opacity: 1;
  transform: translateY(0);
}

.gix-tooltip--incompatible {
  border-left-color: #e64759;
}

.gix-tooltip--warning {
  border-left-color: #d7cb51;
}

.gix-tooltip--compatible {
  border-left-color: #00bc8c;
}

@media screen and (max-height: 820px) and (min-width: 1201px) {
  .main-container {
    margin-top: 12px;
  }
}

@media screen and (max-height: 720px) and (min-width: 1201px) {
  .main-container {
    margin-top: 6px;
  }
}
.background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/img/builder-bg.png'); /* webpack resolves */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0; /* keep it below everything */
}

/* Overlay fixed over background */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    linear-gradient(90deg, rgba(4, 6, 10, 0.88), rgba(6, 8, 12, 0.82) 48%, rgba(4, 6, 10, 0.94)),
    linear-gradient(180deg, rgba(8, 10, 15, 0.48), rgba(8, 10, 15, 0.96));
  opacity: 1;
  z-index: 0;
  pointer-events: none;
}

/* Foreground content */
#app {
  position: relative;
  min-height: 100vh;
}
.darken {
  position: absolute;
  inset: 0;
  background: #191B20;
  opacity: 0.7;
  z-index: 999;
  transition: 0.3s;
  
}
body {
  letter-spacing: 0.1px;
  background-color: #191b20;
  min-width: 340px;
  /* padding-top: 8px; */
  padding-bottom: 0px;
  /* padding-left: 1%;
  padding-right: 1%; */
  /* min-width: 963px; */
}
.bg-dark {
  background-color: #191b20 !important;
  opacity: 0.9;
}
.cart-btn a{
  color: white;
}
.header-inner {
  padding:1.5rem 1.25rem;

}
.gixcore-dropdown {
    padding-top: 2px;
    margin-right: 16px;
    vertical-align: top;
    background-color: rgb(25, 27, 32) !important;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 6px;
}
.info-container {
  display: contents;
}
.footer {
  position: absolute;
  bottom: 0px;
}
.item-list {
  margin-right: -8px;
}
.list-title-mob {
  display: none;
}
@media screen and (max-width: 1200px){
  body {
    padding: 0px;
  }
  .main-container {
    padding-left: 0px;
    margin-top: 20px;
  }
  .searchbar-section {
    /* position: fixed; */
  }
  .item-list {
    height: unset;
    padding-right: 0px;
    overflow: hidden;
    margin-right:0px;
  }
}
@media screen and (max-width: 1000px){
  body {
    font-size: 14px;
  }
  .item-list {
    height: unset;
    padding-right: 0px;
  }
  .small-bullet.value {
    font-size: 14px !important;
  }
  .small-bullet.value {
    font-size: 14px !important;
  }
  .extend-list-button {
    display: none;
  }
  .gixcore-dropdown {
    margin-right: 0px;
  }
  .list-title {
    font-size: 20px;
    height: 28px !important;
  }
  .price li {
    font-size: 20px;
  }
  .tip {
    padding: 3px;
  }
  .demo .img-list {
    height: 105px !important;
    min-width: 105px !important;
  }
  .gc-button {
    height: 32px !important;
    font-size: 18px !important;
  }
  .clone-button {
    padding-top: 3px !important;
    font-size: 16px !important;
  }
}
@media screen and (max-width: 863px){
  .tip {
    min-width: 85px !important;
  }
  .item-desc {
    max-width: 39vw !important;
    white-space: unset !important;
        max-height: 67px;
  }
  .tips-mob {
    display: flex !important;
    margin-top: 4px !important;
    margin-bottom: 0px;
  }
  .tip:last-child {
    margin-right: 2px !important;
  }
  .list-title {
    overflow: hidden;
  }
  li.item.title {
    overflow: hidden !important;
  }
}
@media screen and (max-width: 584px){
  .collapsed-price {
    justify-content: right !important;
    padding-right: 15px !important;
  }
  .header {
    padding-left: 10px;
    padding-right: 10px;
  }

  .builds-container {
    padding-left: 15px !important;
  }
  .build-item {
    width: 100% !important;
  }
  .extended {
    width: 100% !important
  }
  .menu-optoins-buttons .gc-button{
    height: 32px !important
  }
  .collapsed-menu-component {
    display: block;
    position: relative !important;
    width: 100% !important;
    max-height: 100vh !important;
  }
  .list-title-mob {
    display: block;
    margin-top: -8px;
    margin-left: 3px;
    margin-bottom: 6px;
  }
  .tip {
    min-width: 85px !important;
    display: inline-block !important;
    justify-content: space-between;
    /* margin-right: 0px !important; */
    /* border: none !important; */
    /* border-bottom: 1px solid #434857 !important; */
    /* border-radius: 0px !important; */
  }
  .info-container {
    display: block;
    width: 100%;
  }
  .price li {
    text-align: right;
  }
  .list-buttons {
    padding-left: 8px;
        text-align: right;

  }
  .item.title {
    
  }
  .info-list {}
  /* .item.item-desc {
    display: none !important;
  }  */
  .tips-mob {
    display: flex !important;
    margin-top: 4px !important;
    margin-bottom: 0px;
    max-height: 94px;
    overflow: hidden;
  }
  .demo .img-list {
    width: 180px !important;
    height: 140px !important;
  }
  .tip:last-child {
    margin-right: 2px !important;
  }
  .list-title {
    overflow: hidden;
  }
  li.item.title {
    overflow: hidden !important;
  }
  .gc-button {
    height: 31px !important;
  }
  .small-bullet.value {
    /* padding-right: 5px;
    text-align: right !important; */
  }

}
</style>
